import React from 'react';

import { OmModal } from '@om/component-library-react';

const InvestmentAssumptionsModal = ({ open }) => {
    return (
        <OmModal
            open={open}
            closable={false}
            overlayName='field-details'
            hasContinueButton='true'
            isCentered='true'>
            <div slot='modal-content'>
                <h5 className='show-text-two'>
                    <b>Assumptions applied</b> in this calculation
                </h5>
                <p className='result-modal-text-two'>
                    This calculation is based on the past performance of the
                    Money Market Fund. We have applied the most recent rates.
                </p>
                <p>
                    Note that past performance is not necessarily an indication
                    of future performance of a fund, meaning that the earnings
                    calculated here cannot be used as an accurate indication of
                    future earnings.
                </p>
            </div>
        </OmModal>
    );
};

export default InvestmentAssumptionsModal;
